export var sortable_data_types = [
    'text',
    'number',
    'boolean',
    'timestamp',
    'url',
];
export var appDefaultGroups = ['users', 'anonymous', 'registered'];
